import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toPropertyKey from "/usr/app/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["down_payment"],
  _excluded2 = ["down_payment"],
  _excluded3 = ["last_payment"],
  _excluded4 = ["last_payment"];
import React from "react";
var __jsx = React.createElement;
import stl from './InstallmentCalculatorView.module.css';
import { useTranslation } from "@i18n";
import Input from "@/components/UiKit/Input/Input";
import { InstallmentCalculatorProvider, useInstallmentCalculator } from "@/_MiniApps/Installment-calculator/InstallmentCalculatorContext";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { formatNumberWithCommas, getArabicYearWord } from "@/utils/stringHelpers";
import useSubmissionSource from "@hooks/useSubmissionSource";
import EligibilityComponent from "@/_MiniApps/EligibilityComponent/EligibilityComponent";
import { checkTestFlag } from "@/common/config/websiteConfig";
import { dispatchInstallmentCalculatorUpdate, mergeInstallmentCalculatorData, writeInstallmentCalculatorData } from "@/utils/installmentCalculatorStorage";

// Dev-only debug panel (behind TEST_DEBUG_INSTALLMENT_CALC flag) — shows the
// calculation process under a value label. Not user-facing, so text is hardcoded.
var CalcDebug = function CalcDebug(_ref) {
  var lines = _ref.lines;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      direction: 'ltr'
    },
    className: "mt-1 rounded-md border border-solid border-[#EC6234] bg-[#EC6234]/10 p-2 text-left font-mono text-[10px] leading-relaxed text-[#EC6234]"
  }, lines.map(function (l, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i
    }, l);
  }));
};
var InstallmentCalculator = function InstallmentCalculator(_ref2) {
  var _state$road_service, _state$total_financin, _state$total_financin2, _state$down_payment, _state$last_payment, _state$down_payment2, _state$down_payment3, _state$last_payment2;
  var onClose = _ref2.onClose,
    carCondition = _ref2.carCondition,
    isPreowned = _ref2.isPreowned,
    onInteraction = _ref2.onInteraction,
    onDataChange = _ref2.onDataChange,
    propPostId = _ref2.postId,
    onPeriodChange = _ref2.onPeriodChange,
    isEligibleForArib = _ref2.isEligibleForArib;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useInstallmentCalcul = useInstallmentCalculator(),
    state = _useInstallmentCalcul.state,
    setState = _useInstallmentCalcul.setState,
    getCalculatedState = _useInstallmentCalcul.getCalculatedState;
  var showCalcDebug = checkTestFlag("TEST_DEBUG_INSTALLMENT_CALC");
  // Derive warranty (used in calc, not stored separately in state):
  // total_financing_amount_without_down_payment = total_financing_amount - down_payment + warranty + road_service
  var road_service = (_state$road_service = state.road_service) !== null && _state$road_service !== void 0 ? _state$road_service : 0;
  var warranty = ((_state$total_financin = state.total_financing_amount_without_down_payment) !== null && _state$total_financin !== void 0 ? _state$total_financin : 0) - ((_state$total_financin2 = state.total_financing_amount) !== null && _state$total_financin2 !== void 0 ? _state$total_financin2 : 0) + ((_state$down_payment = state.down_payment) !== null && _state$down_payment !== void 0 ? _state$down_payment : 0) - road_service;
  // const {goToScreen} = useModal();
  var _useState = useState({}),
    errors = _useState[0],
    updateErrors = _useState[1];
  var _useState2 = useState(false),
    buttonLoading = _useState2[0],
    setButtonLoading = _useState2[1];
  var params = useParams();
  var postId = propPostId || (params.id ? parseInt(params.id.split('-').pop() || '0') : null);
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;

  // get post id from params
  var _useSubmissionSource = useSubmissionSource(),
    setSubmissionSource = _useSubmissionSource.setSubmissionSource;
  // Set once the user actually edits an input. Guards the persist effect below so
  // merely OPENING the calculator never writes a snapshot — a snapshot's existence
  // is what marks a lead as coming from the calculator (isFromFinanceCalculator /
  // from_finance_calculator), so writing defaults on mount would corrupt that.
  var hasUserChangedValues = useRef(false);
  var handleInputChange = function handleInputChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value;
    // Allow numbers and commas, and strip out invalid characters

    var numericValue = value.replace(/[^0-9,]/g, '');
    // Check if the input is valid and parse it

    var parsedValue = parseFloat(numericValue.replace(/,/g, '')); // Remove commas for parsing
    // Validate empty and negative values
    if (numericValue === '' || parsedValue < 0) {
      var _newState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, name, 0));
      hasUserChangedValues.current = true;
      setState(_newState);
      return;
    }
    onInteraction({
      field: name === 'down_payment' ? 'first_payment' : name
    });
    // Validate down_payment and last_payment
    if (name === 'down_payment' && parsedValue > state.max_down_payment || name === 'last_payment' && parsedValue > state.max_last_payment) {
      updateErrors(_objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, name, t("\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0644\u0644\u062F\u0641\u0639\u0629 \u0627\u0644\u0623\u0648\u0644\u0649  ".concat(state.max_down_payment, "  \u0631\u064A\u0627\u0644"), {
        ns: 'web_common'
      }))));
      return;
    } else {
      // Clear the error if the value is valid
      var _ = errors[name],
        rest = _objectWithoutProperties(errors, [name].map(_toPropertyKey));
      updateErrors(rest);
    }
    // Only update state if the value is valid
    var newState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, name, parsedValue));
    hasUserChangedValues.current = true;
    setState(newState);
  };
  var handleYearChange = function handleYearChange(year) {
    var newState = _objectSpread(_objectSpread({}, state), {}, {
      period: year * 12
    });
    hasUserChangedValues.current = true;
    setState(newState);
    onInteraction({
      field: "financing_period"
    });
    if (onPeriodChange) {
      onPeriodChange(year * 12);
    }
  };

  // Persist the user's choices as soon as they change, not only on submit.
  // The calculator can be dismissed without pressing its finance button — the
  // user then continues through the main CTA (post view -> /pre-checkout ->
  // finance-apply-*), and those pages read this snapshot. Writing only in
  // handleFinanceRequest meant those values were silently lost.
  useEffect(function () {
    if (!hasUserChangedValues.current || !postId) return;
    var calculated = getCalculatedState();
    mergeInstallmentCalculatorData(postId, {
      down_payment: calculated.down_payment,
      last_payment: calculated.last_payment,
      period: calculated.period,
      monthly_installment: calculated.monthly_installment
    });
  }, [postId, state.down_payment, state.last_payment, state.period]);
  var handleFinanceRequest = function handleFinanceRequest() {
    setButtonLoading(true);

    // Recompute instead of reading `state` directly: derived values only catch up
    // on the next render, so a submit right after an input change would persist a
    // stale monthly_installment.
    var calculated = getCalculatedState();
    var calculatorData = {
      down_payment: calculated.down_payment,
      last_payment: calculated.last_payment,
      period: calculated.period,
      monthly_installment: calculated.monthly_installment
    };
    if (onDataChange) {
      onDataChange(calculatorData);
    }
    writeInstallmentCalculatorData(postId, calculatorData);
    dispatchInstallmentCalculatorUpdate(postId, calculatorData);
    setSubmissionSource('finance_calculator');
    setButtonLoading(false);
    onClose();

    // Check current URL to determine correct redirect
    var currentPath = window.location.pathname;
    if (currentPath.includes('/finance-apply-arib')) {
      // Already on Arib page, just add financestep parameter
      navigateTo("/finance-apply-arib?post_id=".concat(postId, "&financestep=1"));
    } else if (isEligibleForArib) {
      navigateTo("/finance-apply-arib?post_id=".concat(postId, "&financestep=1"));
    } else {
      navigateTo("/finance-apply-free/".concat(postId, "?financestep=1"));
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.calculatorViewContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.monthlyPaymentBox
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentBoxTitle
  }, t('monthly_payment', {
    ns: 'web_common'
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentValueBox
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.monthlyPaymentPrice
  }, formatNumberWithCommas(state.monthly_installment)), /*#__PURE__*/React.createElement("span", {
    className: [stl.monthlyPriceUnit, "flex items-center gap-1"].join(" ")
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-4xl"
  }, t('sar', {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-2xl font-semibold leading-normal"
  }, "/", " ", " "), /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, t('monthly', {
    ns: "web_common"
  })))), showCalcDebug && /*#__PURE__*/React.createElement(CalcDebug, {
    lines: ["monthly = \u2308(financing_no_down \u2212 last_payment) / period_months\u2309", "= \u2308(".concat(state.total_financing_amount_without_down_payment, " \u2212 ").concat((_state$last_payment = state.last_payment) !== null && _state$last_payment !== void 0 ? _state$last_payment : 0, ") / ").concat(state.period, "\u2309"), "= ".concat(state.monthly_installment, " SAR")]
  }), /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentBoxNote
  }, carCondition !== 'used' ? t("estimated_monthly_payment_comprehensive_insurance", {
    ns: "web_checkout_finance"
  }) : t("estimated_monthly_payment_comprehensive_insurance_2", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.paymentBoxDivider
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.monthlyPaymentBoxFoter
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.totalFinanceBox
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.totalFinanceText
  }, t('total_financing_amount', {
    ns: 'web_common'
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.totalFinanceNumber
  }, /*#__PURE__*/React.createElement("span", null, formatNumberWithCommas(state === null || state === void 0 ? void 0 : state.total_financing_amount_without_down_payment)), /*#__PURE__*/React.createElement("span", {
    className: [stl.totalFinanceUnit, "text-xl"].join(" ")
  }, t('sar', {
    ts: "web_common"
  })))), /*#__PURE__*/React.createElement("p", {
    className: stl.monthlyPaymentNote
  }, t('total_financing_amount_without_down', {
    ns: 'web_common'
  })), showCalcDebug && /*#__PURE__*/React.createElement(CalcDebug, {
    lines: ["financing_no_down = total_financing \u2212 down_payment + warranty + road_service", "= ".concat(state.total_financing_amount, " \u2212 ").concat((_state$down_payment2 = state.down_payment) !== null && _state$down_payment2 !== void 0 ? _state$down_payment2 : 0, " + ").concat(warranty, " + ").concat(road_service), "= ".concat(state.total_financing_amount_without_down_payment, " SAR"), "  \u2514 road_service = ".concat(road_service, " SAR (\u062E\u062F\u0645\u0629 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0639\u0644\u0649 \u0627\u0644\u0637\u0631\u064A\u0642)"), "\u2500\u2500\u2500\u2500\u2500", "total_financing = purchase_price + insurance + bank_profit", "= ".concat(state.purchase_price, " + ").concat(state.insurance_value, " + ").concat(state.bank_profit, " = ").concat(state.total_financing_amount), "purchase_price = car_price_with_profit + tax = ".concat(state.total_car_price_with_our_profit, " + ").concat(state.added_tax), "insurance = \u2308purchase_price \xD7 ".concat(state.insurance_percent, " \xD7 (").concat(state.period, "/12)\u2309 = ").concat(state.insurance_value), "  \u2514 ".concat(state.insurance_percent, " = annual insurance rate (").concat(state.insurance_percent * 100, "%/yr); ").concat(state.period, "/12 = years"), "bank_profit = \u2308(purchase_price \u2212 down) \xD7 ".concat(state.profit_margin_percent, " \xD7 (").concat(state.period, "/12)\u2309 = ").concat(state.bank_profit), "  \u2514 ".concat(state.profit_margin_percent, " = annual bank profit rate (").concat(state.profit_margin_percent * 100, "%/yr); ").concat(state.period, "/12 = years"), "  \u2514 tax = purchase_price \xD7 ".concat(state.tax_rate, " (").concat(state.tax_rate * 100, "% VAT); our markup rate = ").concat(state.our_profit_percent)]
  }))), /*#__PURE__*/React.createElement(EligibilityComponent, {
    design: "button",
    postID: postId,
    postCondition: carCondition === "used" ? 0 : 1,
    entryPoint: "finance_calculator"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.financePeriodBox
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.financePeriodTitle
  }, t('financing_duration_years', {
    ns: 'web_common'
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.financePeriodYearsBox
  }, Array.from({
    length: state.years
  }, function (_, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: [stl.financePeriodYear, state.period / 12 === i + 1 ? stl.financePeriodYearActive : ''].join(' '),
      key: "financePeriodYear-".concat(i),
      onClick: function onClick() {
        return handleYearChange(i + 1);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: stl.financePeriodYearValue
    }, i + 1), /*#__PURE__*/React.createElement("span", {
      className: stl.financePeriodYearUnit
    }, getArabicYearWord(i + 1, t)));
  })), showCalcDebug && /*#__PURE__*/React.createElement(CalcDebug, {
    lines: ["period_months = selected_years \xD7 12 = ".concat(state.period), "(insurance & bank_profit scale by period/12)"]
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.InputControl
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_checkout_finance"
    }),
    className: [stl.formStyle, errors.down_payment ? stl.inputError : ""].join(" "),
    name: "down_payment",
    label: t("down_payment_2", {
      ns: "web_checkout_finance"
    }),
    type: "string",
    onFocus: function onFocus() {
      if (errors !== null && errors !== void 0 && errors.down_payment) {
        var down_payment = errors.down_payment,
          rest = _objectWithoutProperties(errors, _excluded);
        updateErrors(rest);
      }
    },
    onBlur: function onBlur() {
      if (errors !== null && errors !== void 0 && errors.down_payment) {
        var down_payment = errors.down_payment,
          rest = _objectWithoutProperties(errors, _excluded2);
        updateErrors(rest);
      }
    },
    min: 0,
    max: 7500
    // @ts-ignore
    ,
    onChange: handleInputChange,
    value: formatNumberWithCommas((_state$down_payment3 = state.down_payment) !== null && _state$down_payment3 !== void 0 ? _state$down_payment3 : 0)
  }), /*#__PURE__*/React.createElement("span", {
    className: [stl.inputInfo, errors.down_payment ? stl.inputError : ""].join(" ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t("validation_down_payment_exceed", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.inputInfoMax
  }, formatNumberWithCommas(state.max_down_payment), " "), /*#__PURE__*/React.createElement("span", null, t('sar', {
    ns: "web_checkout_finance"
  })))), showCalcDebug && /*#__PURE__*/React.createElement(CalcDebug, {
    lines: ["".concat(state.max_down_payment_percent, " = max down-payment cap = ").concat(state.max_down_payment_percent * 100, "% of purchase_price"), "max_down = \u230A".concat(state.max_down_payment_percent, " \xD7 purchase_price\u230B"), "= \u230A".concat(state.max_down_payment_percent, " \xD7 ").concat(state.purchase_price, "\u230B = ").concat(state.max_down_payment, " SAR")]
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.inputsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.InputControl
  }, /*#__PURE__*/React.createElement(Input, {
    extraInfo: t("sar", {
      ns: "web_checkout_finance"
    }),
    className: [stl.formStyle, errors.last_payment ? stl.inputError : ""].join(" "),
    name: "last_payment",
    min: 0,
    max: 7500,
    label: t("last_payment_2", {
      ns: "web_checkout_finance"
    }),
    type: "string",
    onFocus: function onFocus() {
      if (errors !== null && errors !== void 0 && errors.last_payment) {
        var last_payment = errors.last_payment,
          rest = _objectWithoutProperties(errors, _excluded3);
        updateErrors(rest);
      }
    },
    onBlur: function onBlur() {
      if (errors !== null && errors !== void 0 && errors.last_payment) {
        var last_payment = errors.last_payment,
          rest = _objectWithoutProperties(errors, _excluded4);
        updateErrors(rest);
      }
    }
    // @ts-ignore
    ,
    onChange: handleInputChange,
    value: formatNumberWithCommas((_state$last_payment2 = state.last_payment) !== null && _state$last_payment2 !== void 0 ? _state$last_payment2 : 0)
  }), /*#__PURE__*/React.createElement("span", {
    className: [stl.inputInfo, errors.last_payment ? stl.inputError : ""].join(" ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t("validation_final_payment_exceed", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: stl.inputInfoMax
  }, formatNumberWithCommas(state === null || state === void 0 ? void 0 : state.max_last_payment), " "), /*#__PURE__*/React.createElement("span", null, t('sar', {
    ns: "web_checkout_finance"
  })))), showCalcDebug && /*#__PURE__*/React.createElement(CalcDebug, {
    lines: ["".concat(state.max_last_payment_percent, " = max last-payment cap = ").concat(state.max_last_payment_percent * 100, "% of purchase_price"), "max_last = \u230A".concat(state.max_last_payment_percent, " \xD7 purchase_price\u230B"), "= \u230A".concat(state.max_last_payment_percent, " \xD7 ").concat(state.purchase_price, "\u230B = ").concat(state.max_last_payment, " SAR")]
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.footerDivider
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.ctaWrapper
  }, /*#__PURE__*/React.createElement("button", {
    className: stl.financeCta,
    onClick: function onClick() {
      return !buttonLoading && handleFinanceRequest();
    },
    disabled: Object.keys(errors).length > 0
  }, buttonLoading ? /*#__PURE__*/React.createElement("span", {
    className: stl.loader
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, t('get_car_financed', {
    ns: 'web_common'
  }))))));
};
var InstallmentCalculatorView = function InstallmentCalculatorView(_ref3) {
  var carCondition = _ref3.carCondition,
    cashPrice = _ref3.cashPrice,
    isPreowned = _ref3.isPreowned,
    onClose = _ref3.onClose,
    onInteraction = _ref3.onInteraction,
    onDataChange = _ref3.onDataChange,
    postId = _ref3.postId,
    initialValues = _ref3.initialValues,
    dynamicFinanceCalculatorData = _ref3.dynamicFinanceCalculatorData,
    onPeriodChange = _ref3.onPeriodChange,
    isEligibleForArib = _ref3.isEligibleForArib;
  return /*#__PURE__*/React.createElement(InstallmentCalculatorProvider, {
    carCondition: carCondition,
    cashPrice: cashPrice,
    initialValues: initialValues,
    isPreowned: isPreowned,
    dynamicFinanceCalculatorData: dynamicFinanceCalculatorData
  }, /*#__PURE__*/React.createElement(InstallmentCalculator, {
    onClose: onClose,
    carCondition: carCondition,
    onInteraction: onInteraction,
    onDataChange: onDataChange,
    postId: postId,
    isPreowned: isPreowned,
    onPeriodChange: onPeriodChange,
    isEligibleForArib: isEligibleForArib
  }));
};
export default InstallmentCalculatorView;